// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/authReducer';
import entityReducer from './reducers/entityReducer';
import userReducer from './reducers/userReducer';
import roleReducer from './reducers/roleReducer';
import permissionReducer from './reducers/permissionReducer';
import referenceReducer from './reducers/referenceReducer';
import uiReducer from './reducers/uiReducer';
import { authService } from '../services/authService';
import { garageReducer } from './reducers/garageReducer';
import agencyReducer from './reducers/agencyReducer';
import serviceReducer from './reducers/serviceReducer';
import attestationReducer from './reducers/attestationReducer';
import blogPostReducer from './reducers/blogPostReducer'; // 
import categoryReducer from './reducers/categoryReducer';
import tagReducer from './reducers/tagReducer'; // Import tag reducer
import faqReducer from './reducers/faqReducer'; // Import FAQ reducer
import productReducer from './reducers/productReducer';
// Import other reducers as needed

export const store = configureStore({
  reducer: {
    auth: authReducer,
    entities: entityReducer,
    users: userReducer,
    roles: roleReducer,
    permissions: permissionReducer,
    reference: referenceReducer,
    ui: uiReducer,
    garages: garageReducer,
    agencies: agencyReducer,
    services: serviceReducer,
    attestations: attestationReducer,
    blogPosts: blogPostReducer,
    categories: categoryReducer,
    tags: tagReducer,
    faqs: faqReducer,
    products: productReducer,
    // other reducers...
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: { authService },
      },
    }),
});

export default store;